<app-admin-student-platform-header> </app-admin-student-platform-header>

<section class="payments">

  <!-- HEADER -->
  <div class="header">
    <div>
      <h1>Payments & Invoices</h1>
      <p>Track payments and manage invoices</p>
    </div>

  </div>

  <!-- STATS -->
  <div class="stats">
    <div class="stat-card success">
      <span class="material-icons">check_circle</span>
      <div>
        <p>Successful Payments</p>
        <h3>₹{{ dashboardStats.total_payments_amount }}</h3>
      </div>
    </div>

    <div class="stat-card failed">
      <span class="material-icons">cancel</span>
      <div>
        <p>Failed Payments</p>
        <h3>₹{{ dashboardStats.failed_payments }}</h3>
      </div>
    </div>

    <div class="stat-card info">
      <span class="material-icons">receipt_long</span>
      <div>
        <p>Total Transactions</p>
        <h3>{{ dashboardStats.total_transactions }}</h3>
      </div>
    </div>
  </div>

  <!-- SEARCH -->
  <div class="search-row">
    <div class="search-box">
      <span class="material-icons">search</span>
      <input type="text" placeholder="Search by user or transaction ID..." [(ngModel)]="searchTerm"
        (input)="onSearch()" />
    </div>
    <div class="status-filter-wrapper">
      <i class="bi bi-funnel filter-icon"></i>

      <select class="status-filter" [(ngModel)]="paymentStatus" (change)="onStatusChange()">
        <option value="all">All</option>
        <option value="pending">Pending</option>
        <option value="completed">Success</option>
        <option value="failed">Failed</option>
        <option value="refunded">Refunded</option>
      </select>
      <i class="bi bi-chevron-down dropdown-arrow"></i>
    </div>
  </div>
  <!-- TABLE -->
  <div class="table-wrapper" *ngIf="payments.length; else noData">
    <table>
      <thead>
        <tr>
          <th>User</th>
          <th>Transaction ID</th>
          <th>Amount</th>
          <th>Date</th>
          <th>Status</th>
          <th>Invoice</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of payments">
          <td>{{ item.user_name }}</td>
          <td class="txn">{{ item.transaction_id || '-' }}</td>
          <td>₹{{ item.amount }}</td>
          <td>{{ item.payment_date || '-' }}</td>
          <td>
            <span class="badge" [ngClass]="item.status.toLowerCase()">
              {{ item.status }}
            </span>
          </td>
          <td>
			<ng-container *hasPermission="PermissionForStudents.INVOICE_DOWNLOAD">
            <button class="pdf-btn" (click)="downloadInvoice(item.order_id)"
            [disabled]="item.status !== 'Success'">
              <span class="material-icons">download</span> PDF
            </button>
			</ng-container>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- PAGINATION -->
    <div class="pagination" *ngIf="totalRecords > pageSize">
      <div class="page-controls">
        <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">‹</button>

        <button *ngFor="let p of pages" (click)="changePage(p)" [class.active]="currentPage === p">
          {{ p }}
        </button>

        <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">›</button>
      </div>
      <p>
        Showing
        {{ (currentPage - 1) * pageSize + 1 }} –
        {{ getEndIndex() }}
        of {{ totalRecords }} records
      </p>
    </div>
  </div>

  <!-- NO DATA -->
  <ng-template #noData>
    <div class="no-data">
      <span class="material-icons">receipt</span>
      <h3>No transactions found</h3>
      <p>Try adjusting your search or filters</p>
    </div>
  </ng-template>

</section>